import { useContext, useEffect, useState, useEffectEvent } from 'react';
import { JSEncrypt } from 'jsencrypt';
import { useTranslation } from 'react-i18next';
import { OTP, Typography } from 'mobily-ui-library';
import { GlobalContext } from '../../../context/GlobalContext';

import { notifyMeOTPValidate, cemResendOTP, notifyMe } from '../../../api/api';

import HeaderNavigation from '../../common/HeaderNavigation/HeaderNavigation';
import ErrorModal from '../../ErrorModal/ErrorModal';
import SuccessModal from '../../SuccessModal/SuccessModal';

import SucessImg from '../../../assets/Success.svg';
import './NotifyMeOTP.scss';

const win: any = window;
interface Props {
    handleHeaderCancel: () => void;
}

function NotifyMeOTP({ handleHeaderCancel }: Props) {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, productData, homePageUrl, notifyData, lang } = state;
    const { mobile, email, refId } = notifyData;

    const { t } = useTranslation()

    const [timer, setTimer] = useState(120);
    const [otpValue, setotpValue] = useState('');
    const [showOTPError, setShowOTPError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isGenericError, setIsGenericError] = useState(false);
    const [resendOption, setResendOption] = useState(true);
    const [isOTPDisabled, setIsOTPDisabled] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
    const [isSuccessScreen, setIsSuccessScreen] = useState(false);
    const [maxOTPRetry, setMaxOTPRetry] = useState(false);


    const publicKey = win['public_key'];
    const jsencrypt = new JSEncrypt();
    jsencrypt.setPublicKey(publicKey);

    const onCountDown = useEffectEvent(() => {
        setTimer((prevTimer: any) => {
            if (prevTimer > 0) {
                return prevTimer - 1;
            }
            return 0;
        });
    });

    useEffect(() => {
        let countdown: any;
        countdown = setInterval(() => {
            onCountDown();
        }, 1000);
        return () => clearInterval(countdown);
    }, [onCountDown]);

    const formatTime = (time: any) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const handleOTPChange = (otp: any) => {
        setotpValue(otp);
        setShowOTPError(false);
        if (otp.length === 4) {
            dispatch({ type: "LOADER", payload: { loading: true } });
            dispatch({ type: "CAPTURE_OTP_VALUE", payload: { otpValue: otp } });
            notifyValidateOTPAPI(otp)
        }
    }

    const notifyValidateOTPAPI = (otp: any) => {
        notifyMeOTPValidate(otp, refId).then((res: any) => {
            if (res.status === 204) {
                dispatch({ type: "LOADER", payload: { loading: true } });
                notifyMeApi();
            } else if (res?.status === 260) {
                // Handle otp error cases
                switch (res?.data?.status?.sourceCode) {
                    case "MAPI-260-2":
                        setErrorMessage(t("error_Invalid_OTP"));
                        setShowOTPError(true);
                        break;
                    case "MAPI-260-3":
                        setErrorMessage(t("error_OTP_expired"));
                        setShowOTPError(true);
                        break;
                    case "MAPI-260-4":
                        setErrorMessage(t("error_Max_attempt_reached"));
                        setMaxOTPRetry(true)
                        break;
                    default:
                        setIsGenericError(true);
                        break;
                }
                setTimer(0);
                setotpValue('');
                dispatch({ type: "LOADER", payload: { loading: false } });
            } else {
                setIsGenericError(true);
                dispatch({ type: "LOADER", payload: { loading: false } });
            }
        }).catch(() => {
            setIsGenericError(true);
            dispatch({ type: "LOADER", payload: { loading: false } });
        })
    }

    const notifyMeApi = () => {
        const mobileNumber = mobile.replace(/^0/, "966")
        const EnMobileNumber = mobileNumber ? jsencrypt.encrypt(mobileNumber) : "";
        const EnEmail = email ? jsencrypt.encrypt(email) : "";
        const pageUrl = window.location.href;
        let pagePath = "";
        if (pageUrl.includes("web/")) {
            pagePath = pageUrl.split("web/")[1];
        } else if (pageUrl.includes("wps/wcm/connect/")) {
            pagePath = pageUrl.split("wps/wcm/connect/")[1];
        }
        console.log("pagePath", pagePath);
        const EnPageUrl = pagePath ? jsencrypt.encrypt(pagePath) : "";
        let notificationChannel = "";
        if (mobileNumber && email) {
            notificationChannel = "all";
        } else if (mobileNumber) {
            notificationChannel = "sms";
        } else if (email) {
            notificationChannel = "email";
        }

        const request = {
            email: EnEmail,
            msisdn: EnMobileNumber,
            poid: productData?.id,
            sku: productData?.sku,
            lang: lang,
            otpReferenceId: refId,
            notificationChannel,
            extraInfo: [{
                key: "context",
                value: EnPageUrl
            }]
        };

        notifyMe(request)
            .then((res: any) => {
                if (res.status === 200 && res.data.status.code === "CEM_0000") {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    setIsSuccessScreen(true)
                }
                else if (res.status === 409 && res.data.status.code === "CEM_0001") {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    setErrorModal(true)
                } else {
                    setIsGenericError(true);
                    dispatch({ type: "LOADER", payload: { loading: false } });
                }
            }).catch(err => {
                console.log("error", err)
            })
    }

    const handleResend = () => {
        dispatch({ type: "LOADER", payload: { loading: true } })

        cemResendOTP(refId)
            .then((res: any) => {
                if (res?.status === 204) {
                    setotpValue('');
                    setIsOTPDisabled(false);
                    dispatch({ type: "LOADER", payload: { loading: false } })
                    setTimer(120);
                    setShowOTPError(false);
                } else if (res?.status === 260 && res?.data?.status?.sourceCode === "MAPI-260-1") {
                    setTimer(0);
                    setotpValue('');
                    setResendOption(false);
                    setMaxOTPRetry(true)
                    setErrorMessage(t("You_exceeded_the_maximum_amount_of_requests"));
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    setIsGenericError(true);
                }
            })
    }

    const handleBackArrow = () => {
        dispatch({ type: 'NOTIFY_SUB_PAGE_TO_DISPLAY', payload: { notifysubPageToDisplay: "notifyMeLogin" } })
    }

    const handleSubmittedError = () => {
        dispatch({ type: 'LOADER', payload: { loading: true } });
        setErrorModal(false);
        document.body.style.overflow = 'auto';
        window.location.reload();
    }

    const handleGenericError = () => {
        setIsGenericError(false);
        dispatch({ type: 'LOADER', payload: { loading: false } });
        window.location.reload();
    }

    const handleSuccess = () => {
        setIsSuccessScreen(false)
        window.location.href = homePageUrl;
    }

    return (
        <>
            <HeaderNavigation
                rtl={rtl}
                percent={100}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
                handleHeaderCancel={handleHeaderCancel}
            />
            <div className='Verify__Container'>
                <div className='SL__headerText'>
                    <Typography rtl={rtl} id="verify-heading" className='SL__heading'>{t('Confirm_its_you')}</Typography>
                    <Typography rtl={rtl} id="verify-Subheading" className='SL__subHeading'>
                        {t('VerifyMe_Subheading')}
                        <div className='Verify__Msisdn'>{mobile}</div>
                        <div>{t('Verify_ToContinue')}</div>
                    </Typography>
                </div>

                <div className='Verify__OTP'>
                    <OTP id="otp-input" isDisabled={isOTPDisabled} rtl={rtl} numInputs={4} onChange={handleOTPChange} value={otpValue} />
                    {timer > 0 ? (
                        <Typography id="resend-code" rtl={rtl} className='Verify__timer'>
                            {t('Verify_ResendNewCode')} <span>{formatTime(timer)}</span>
                        </Typography>
                    ) : showOTPError ? (
                        <Typography className='Verify__otpError' rtl={rtl}>
                            {`${errorMessage} `}
                            {resendOption && <span id='resend-otp' className='Verify__sendAgain_error' onClick={handleResend}>
                                {t("Send_again")}
                            </span>}

                        </Typography>
                    ) : (
                        <Typography className='Verify__Resend' rtl={rtl}>
                            {t("Didnt_receive_the_code")}
                            <span id='resend-otp' className='Verify__sendAgain' onClick={handleResend}>
                                {t("Send_again")}
                            </span>
                        </Typography>
                    )}
                </div>

                {errorModal && (
                    <ErrorModal
                        id='Request_submitted'
                        rtl={rtl}
                        title={t('Request_submitted')}
                        description={t('already_subscribed')}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleSubmittedError}
                    />
                )}

                {isGenericError && (
                    <ErrorModal
                        id={'otp_page_generic_error'}
                        rtl={rtl}
                        title={t('Generic_error')}
                        description={""}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleGenericError}
                    />
                )}
                {maxOTPRetry && (
                    <ErrorModal
                        id={'otp_Maximum_Retry'}
                        rtl={rtl}
                        title={errorMessage}
                        description={""}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleGenericError}
                    />
                )}




                {isSuccessScreen && (
                    <SuccessModal
                        id={'otp_page_generic_error'}
                        rtl={rtl}
                        imgSrc={SucessImg}
                        title={t('Request_submitted')}
                        description={t('You_will_be_notified')}
                        buttonText={t('Got_it')}
                        modalButtonClick={handleSuccess}

                    />
                )}
            </div>
        </>
    )
}

export default NotifyMeOTP